// extracted by mini-css-extract-plugin
module.exports = {"buttonCheckBox":"classes_buttonCheckBox__YgxYF","CheckboxButton":"classes_CheckboxButton__3z4Xf"};